.createChatDialogBody {
  height: 100vh;
}

.addMemberDialogBody {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.addMemberContactList {
  flex-grow: 1;
}

.AddMemberChipsWrapper {
  border-bottom: solid 2px #d3d3d3;
  max-height: 33%;
  overflow-y: scroll;
  padding-inline-start: 19px;
  padding-inline-end: 30px;
}
.AddMemberChipsWrapper .AddMemberChips {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-inline-start: -5px;
  margin-inline-end: -5px;
}
.AddMemberChipsWrapper .AddMemberChips .AddMemberChip {
  display: flex;
  width: auto;
  max-width: fit-content;
  margin: 5px;
  background-color: var(--addMemberChipBackgroundColor);
  border-radius: 25px;
  padding: 4px 5px 0px 4px;
}
.AddMemberChipsWrapper .AddMemberChips .AddMemberChip .DisplayName {
  display: flex;
  align-items: center;
  padding-inline-end: 6px;
  padding-bottom: 4px;
  margin-inline-start: 5px;
}
.AddMemberChipsWrapper .AddMemberChips .AddMemberChip .DisplayName div {
  max-width: 90px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.AddMemberChipsWrapper .AddMemberChips .AddMemberChip .Avatar {
  height: var(--local-height);
}
.AddMemberChipsWrapper .AddMemberChips .AddMemberChip .Avatar .content {
  margin: 0px !important;
}
.AddMemberChipsWrapper .AddMemberChips .AddMemberChip .removeMember {
  background-color: #777;
  border: none;
  border-radius: 15px;
  padding: 3px;
  padding-top: 2px;
  height: 18px;
  margin-top: 9px;
}
.AddMemberChipsWrapper .AddMemberChips .AddMemberChip .removeMember .removeIcon {
  cursor: pointer;
  background-color: #fff;
}
.AddMemberChipsWrapper .AddMemberChips .groupMemberSearch {
  display: flex;
  line-height: var(--local-height);
  height: var(--local-height);
  width: 90px;
  margin: 5px;
  margin-top: 8px;
}